import {BaseContainerModel} from '../base-container.model';


export class RequestRefundEmailModel extends BaseContainerModel {
  email_to = '';
  email_title =  '';
  email_body = '';
}
